import React from "react";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import { getOpdLabTestStatus, getIpdLabTestStatus } from "../labTestWorkflowUtils";

const detailsBoxSx = {
  mb: 1.5,
  p: 1.25,
  border: "1px solid #e0e0e0",
  borderRadius: 1,
  bgcolor: "#fafafa",
};

const formatIpdDate = (testDate) => {
  if (!testDate) return "—";
  if (Array.isArray(testDate)) {
    return dayjs(
      new Date(testDate[0], testDate[1] - 1, testDate[2], testDate[3] || 0, testDate[4] || 0)
    ).format("D MMM YYYY");
  }
  return dayjs(testDate).format("D MMM YYYY");
};

export const OpdWorkflowDetails = ({ prescription, statusFilter }) => {
  if (!prescription) return null;

  const testNames = (prescription.patientLabTests || [])
    .filter((test) => !statusFilter || getOpdLabTestStatus(test) === statusFilter)
    .map((test) => test.testName)
    .filter(Boolean);

  return (
    <Box sx={detailsBoxSx}>
      <Typography variant="body2">
        <strong>Patient Name:</strong> {prescription.patientName || "—"}
      </Typography>
      <Typography variant="body2">
        <strong>Doctor:</strong> {prescription.doctorName || "—"}
      </Typography>
      <Typography variant="body2">
        <strong>Prescription Date:</strong>{" "}
        {prescription.createdAt ? dayjs(prescription.createdAt).format("D MMM YYYY") : "—"}
      </Typography>
      <Typography variant="body2">
        <strong>Test:</strong> {testNames.length > 0 ? testNames.join(", ") : "—"}
      </Typography>
    </Box>
  );
};

export const IpdWorkflowDetails = ({ group, statusFilter }) => {
  if (!group) return null;

  const testNames = (group.labTests || [])
    .filter((test) => !statusFilter || getIpdLabTestStatus(test) === statusFilter)
    .map((test) => test.resolvedTestName || test.testName)
    .filter(Boolean);

  return (
    <Box sx={detailsBoxSx}>
      <Typography variant="body2">
        <strong>Patient Name:</strong> {group.patientName || "—"}
      </Typography>
      <Typography variant="body2">
        <strong>Doctor:</strong> {group.doctorName || group.assignedByName || "—"}
      </Typography>
      <Typography variant="body2">
        <strong>Test Date:</strong> {formatIpdDate(group.testDate)}
      </Typography>
      <Typography variant="body2">
        <strong>Test:</strong> {testNames.length > 0 ? testNames.join(", ") : "—"}
      </Typography>
    </Box>
  );
};
